<template>
    <v-dialog v-model="show" width="820" persistent no-click-animation>
        <div class="ManagePermissionEditor">
            <!--Dialog header-->
            <div class="dialog-header">
                <div>{{ $f.tc('managePermission') }}: {{
                        QCCampaign ? $utils.limitStringLength(QCCampaign.name, 45) : ''
                    }}
                </div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Dialog content-->
            <div class="scrollbar-thin editor-content">
                <!--List user permission-->
                <SimpleDataTable
                    :headers="headers"
                    :items="dataTable"
                    :hide-pager="true"
                >
                    <template v-slot:action="props">
                        <v-btn icon small @click="userToDelete = props.item ; showConfirmOverlay = true">
                            <img src="/img/delete-member.svg" alt="icon-delete"
                                 style="transform: scale(0.9); padding-left: 1px">
                        </v-btn>
                    </template>
                </SimpleDataTable>
                <div class="btn-custom-normal" @click="isShowAddMember = true" v-show="!isShowAddMember">
                    <img src="/img/add-member.svg" alt="icon-add" style="padding-right: 6px">
                    {{ $f.tc('addMember') }}
                </div>
                <v-form v-show="isShowAddMember" class="table-add-member" v-model="formValid"
                        @click="openQCPermissionCreator"
                        ref="form">
                    <div class="item-new-member">
                        <v-text-field
                            v-model="model.email"
                            :rules="formRules.email"
                        ></v-text-field>
                    </div>
                    <div class="item-new-member">
                        <v-select
                            outlined
                            v-model="model.permission"
                            :rules="formRules.required"
                            :items="permissionList"
                        ></v-select>
                    </div>
                    <div class="item-new-member">
                        <v-btn icon small @click="submit" class="btn-icon">
                            <img src="/img/save-member.svg" alt="icon-save"
                                 style="transform: scale(0.9); padding-left: 1px">
                        </v-btn>
                    </div>
                </v-form>
                <confirm-overlay
                    :show="showConfirmOverlay"
                    title="Remove User"
                    :text="userToDelete.email"
                    @disagree="showConfirmOverlay = false; userToDelete = false"
                    @agree="showConfirmOverlay = false; deleteUserPermissions(userToDelete.id)"></confirm-overlay>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import SimpleDataTable from '@/components/SimpleDataTable'
import ConfirmOverlay from '@/components/ConfirmOverlay'
import QcCampaignService from "@/services/qc.campaign.service";
import {mapState} from "vuex";
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";


export default {
    name: 'QCPermissionEditor',
    components: {
        SimpleDataTable,
        ConfirmOverlay
    },
    mixins: [DialogPromiseFormMixin],
    props: {
        onSaved: Function
    },
    data() {
        return {
            formValid: false,
            show: false,
            QCCampaign: null,
            dataTable: [],
            showConfirmOverlay: false,
            userToDelete: false,
            isShowAddMember: false,
            permissionList: [],
            model: {
                permission: '',
                email: ''
            }
        }
    },
    computed: {
        ...mapState({
            profile: state => state.user.profile,
        }),
        headers() {
            return [
                {
                    text: this.$filters.capitalize(this.$t('email')),
                    value: 'email',
                    sortable: false
                },
                {
                    text: this.$filters.capitalize(this.$t('permission')),
                    value: 'permission',
                    sortable: true
                },
                {
                    text: '',
                    value: 'action',
                    sortable: false,
                    type: 'custom',
                    id: 'action'
                }
            ]
        }
    },
    methods: {
        open(QCCampaign) {
            this.show = true
            this.QCCampaign = QCCampaign
            this.getRoles()
        },
        close() {
            this.show = false
            this.isShowAddMember = false
        },
        getRoles() {
            QcCampaignService.getQCCampaignRoles().then(
                result => {
                    this.permissionList = result.data.map(item => {
                        return {
                            text: item.name,
                            value: item.permission
                        }
                    })
                },
                this.$appService.handleRequestError('can not load qc campaign roles')
            )
        },
        loadUserPermissions() {
            this.$appService.showLoading()
            QcCampaignService.UserPermissionService.search(this.QCCampaign.id).then(
                result => {
                    this.dataTable = result.data
                    this.$appService.hideLoading()
                }
            )
        },
        deleteUserPermissions(userId) {
            this.$appService.showLoading()
            const i18n = {
                action: this.$t('delete'),
                item: this.$t('permission')
            }
            QcCampaignService.UserPermissionService.delete(this.QCCampaign.id, userId).then(
                result => {
                    this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                    this.userToDelete = false
                    this.loadUserPermissions()
                })
        },
        importPermission() {
            this.$refs.inputPermission.click()
        },
        handleFile(event) {
            this.file = event.target.files[0]
            let extFile = this.file.name.split('.').pop()
            if (this.file.size <= 1024 * 1024 && ['xlsx', 'csv', 'xls'].includes(extFile)) {
                let formData = new FormData()
                formData.append('file', this.file)
                this.$appService.showLoading()
                QcCampaignService.importQCCampaignPermission(this.QCCampaign.id, formData).then(
                    res => {
                        const i18n = {
                            action: this.$t('save'),
                            item: this.$t('permission')
                        }
                        this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n) + ': ' + res.data.import_success)
                        this.$appService.toastError(this.$f.tc('actionFailed', i18n) + ': ' + res.data.import_fail.count)
                        this.loadUserPermissions()
                    }
                ).catch(
                    err => {
                        this.$appService.toastError(err)
                    }
                ).finally(() => {
                    this.$appService.hideLoading()
                    this.file = null
                    this.$refs.inputPermission.value = null
                })

            } else {
                this.$appService.toastError('invalid file')
            }
        },
        downloadTemplateUserPermission() {
            QcCampaignService.getCampaignPermissionTemplate(this.QCCampaign.id).then(res => {
                this.$utils.saveFile(res.data, this.$filters.replaceSpecialCharacters(this.$utils.nonAccentVietnamese(this.QCCampaign.title + ' - QCCampaign permission template')), '.xlsx')
            })
        },
        openQCPermissionCreator() {
            this.$refs.form.open().then(model => {
                const i18n = {
                    action: this.$t('assign'),
                    item: this.$t('permission')
                }
                QcCampaignService.UserPermissionService.create(this.QCCampaign.id, model).then(() => {
                        this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                        if (this.onSaved) {
                            this.onSaved()
                        }
                        this.loadUserPermissions()
                    }
                )
            })
        },
        submitValidForm() {
            const i18n = {
                action: this.$t('assign'),
                item: this.$t('permission')
            }
            QcCampaignService.UserPermissionService.create(this.QCCampaign.id, this.model).then(() => {
                    this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                    if (this.onSaved) {
                        this.onSaved()
                    }
                    this.loadUserPermissions()
                }
            ).catch(() => {
                this.$appService.toastError(this.$f.tc('actionFailed', i18n))
            }).finally(
                () => {
                    this.clearForm()
                }
            )

        }
    },
    watch: {
        QCCampaign: {
            immediate: true,
            handler: function () {
                if (this.QCCampaign) {
                    this.loadUserPermissions()
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.ManagePermissionEditor {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-header {
        background: #F4F7FE;
    }

    .editor-content {
        padding: 10px;

        .btn-custom-normal {
            height: 39px !important;
            border-radius: 0 !important;
            justify-content: left;
            color: #0052CC;
            font-size: 14px;
            font-family: "open sans bold";
            font-style: normal;
            text-align: center;
        }
    }

    .editor-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 10px;
    }

    .btn-custom {
        margin-left: 8px;
    }
}

::v-deep {
    .v-table__overflow {
        overflow-y: auto;
        border: 1px solid #DADFEC;
        border-bottom: none;
        max-height: 450px;


        thead tr:not(.v-datatable__progress) {
            height: 40px !important;
            border-bottom: none;
            padding: 0 !important;

        }

        thead tr th {
            text-transform: capitalize !important;
            color: #12274F !important;
            background: #F4F7FE;
            border-right: 1px solid #DADFEC;
            padding: 0 10px 0 10px;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 500px;
            }

            &:nth-child(2) {
                width: 200px;
            }

        }

        tbody tr td {
            height: 40px !important;
            border-right: 1px solid #DADFEC;
            padding: 0 10px 0 10px;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 500px;
            }

            &:nth-child(2) {
                width: 200px;
            }

            &:nth-child(3) {
                text-align: center;
            }
        }
    }

    .v-input__slot {
        height: 37px;
        background: #FFFFFF;
        outline: none;
        font-size: 14px;
        padding: 0 12px;
        margin: 0;
        display: flex;
        align-items: center;
        position: relative;
        border-bottom: 1px solid #DADFEC;

        &:before, &:after {
            border: none !important;
        }
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 12px;
    }

    .v-select {
        background: #00c1dc;

        .v-text-field__details {
            right: 40px !important;
            top: 10px !important;
        }
    }

    .v-text-field {
        padding-top: 0 !important;
    }
}

.table-add-member {
    border: 1px solid #DADFEC;
    display: flex;

    .item-new-member {
        height: 40px;
        border-right: 1px solid #DADFEC;

        &:last-child {
            border-right: none;
        }

        &:nth-child(1) {
            position: relative;
            margin: 0 !important;
            width: 501px;
        }

        &:nth-child(2) {
            margin: 0 !important;
            width: 200px;
        }

        &:nth-child(3) {
            flex: 1;
            margin: 0 !important;
            background: #0052CC;
            text-align: center;
            border-color: #0052CC;
        }
    }
}
</style>
